import { UtensilsCrossed } from 'lucide-react';

const MenuEmpty = () => {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center px-5 text-center sm:px-7">
      <span className="rounded-xl border border-primary/15 bg-primary/10 p-4 text-primary dark:border-primary/25 dark:bg-primary/15">
        <UtensilsCrossed className="h-8 w-8" />
      </span>

      <h3 className="mt-4 font-semibold text-black dark:text-white">
        No hay ítems para mostrar
      </h3>

      <p className="mt-1 max-w-md text-sm text-bodydark2 dark:text-bodydark">
        Cree una categoría, agregue productos al menú o cambie los filtros
        seleccionados.
      </p>
    </div>
  );
};

export default MenuEmpty;